import React from "react";
import { ButtonProps } from "./ButtonProps";
import classNames from "classnames";
import styles from "./Button.module.scss";

const Button = ({ value, onClick, isDisabled }: ButtonProps) => {
  return (
    <button
      className={classNames(styles.button, isDisabled && styles.disabled)}
      onClick={() => onClick()}
      disabled={isDisabled}
    >
      {value}
    </button>
  );
};

export default Button;
